// extracted by mini-css-extract-plugin
export default {"container":"DropzoneInput_container__W9OzA"};